export default __webpack_public_path__ + "static/media/create-profile-modal@2x.0061cf12.png";